import * as Enum from '@uuhsc/cores-app-library/enum';

const {
  auth_mode,
  user_roles,
  OBJECT_STATUS,
  WORKFLOW_STATUS,
  getObjectStatus,
} = Enum;

export {
  auth_mode,
  user_roles,
  OBJECT_STATUS,
  WORKFLOW_STATUS,
  getObjectStatus,
};
